import React from "react"

import {FieldViewProps} from "../../../../render/view"
import {ProjectIconDictionary} from "../../../../../gd/const/project"
import {ProjectSystemTypeIcon} from "../../../../../model2/project/types"

const debug = false
// const debug = "FieldProjectIcon_View"

export default function FieldProjectIcon_View(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    let iconClass = ProjectIconDictionary[value as keyof {}]
    if (!iconClass) {
        iconClass = ProjectIconDictionary[ProjectSystemTypeIcon[props.model.systemType as keyof {}]]
    }

    debug && console.log(debug, 'render', iconClass, value, props.model)

    const size = _.get(props.options, 'size', '14')

    const classes = Classes("gd-ui-project-icon", "ui5-ico-{0}".f(size), iconClass, props.className)

    return <div className={classes} onClick={props.onClick}/>

}